import miniToastr from 'mini-toastr';
import pagination from './/Pagination';

export function handlePaging(_com, resp, options) {
  const com = _com;
  com.pagination.total = resp.total;
  com.pagination.from = options.offset;
  com.pagination.to = options.offset + options.count;
  if (com.pagination.to > com.pagination.total) {
    com.pagination.to = com.pagination.total;
  }
  com.pagination.last_page = Math.ceil(com.pagination.total / options.count);
}

export function mixinPager(com) {
  const vm = com;
  const data = vm.data();
  const created = (com.created || (() => {}));
  let baseTime = 0;
  vm.methods.loadData = function ld() {
    if (this.needLoad && !this.needLoad()) {
      return;
    }
    const options = {
      offset: (this.pagination.current_page - 1) * this.pagination.per_page,
      count: this.pagination.per_page,
      base: baseTime,
    };
    const service = vm.service || 'findAll';
    vm.mainService[service]({
      ...this.condition, ...options, ...this.params,
    }).then((resp) => {
      this[vm.dataKey] = resp.dataList;
      baseTime = resp.base;
      console.log(options);
      handlePaging(this, resp, options);
      if (!this[vm.dataKey] || !this[vm.dataKey].length) {
        // miniToastr.success('未找到相关数据');
      }
    }, (resp) => {
      miniToastr.error(resp && resp.error, '加载失败');
    });
  };
  vm.methods.search = function sh() {
    this.loadData();
  };
  vm.created = function create() {
    created.apply(this);

    if (vm.forbidInitalReload !== true) {
      this.loadData();
    }
  };
  vm.data = function dat() {
    return {
      ...data,
      pagination: {
        total: 0,
        per_page: 10,    // required
        current_page: 1, // required
        last_page: 0,    // required
        from: 1,
        to: 10,           // required
      },
      paginationOptions: {
        offset: 4,
        previousText: '上一页',
        nextText: '下一页',
        alwaysShowPrevNext: true,
      },
    };
  };
  if (vm.components) {
    vm.components.pagination = pagination;
  } else {
    vm.components = {
      pagination,
    };
  }
  return vm;
}



// WEBPACK FOOTER //
// ./src/reusable/pager.js